const BrowseLayer = ({children}) => (
    <div className="browse-layer">
        <div className="browse">
            {children}
        </div>
    </div>
);

export default BrowseLayer;
